"use client";
import React from "react";
import { CircularProgress } from "../../../components/UI/CircularProgress";
import { CheckMarkIcon } from "../../../constants/icons";
import images from "../../../constants/images";
export default function StepTwo() {
  return (
    <>
      <div className="relative h-screen w-full flex justify-center items-center">
        <img
          className="absolute top-0 motion-safe:animate-slowPing h-full w-full object-cover"
          src={images.Celebration}
          alt="Success Celebration"
        />
        <div className="relative h-[70%] flex flex-col gap-2 md:gap-6 justify-center items-center w-full xl:w-1/2">
          <div className="w-[100%] flex justify-center items-center">
            <CircularProgress value={100} />
          </div>
          <div className="animate-bounce flex flex-row justify-center items-center gap-2 w-1/2 text-nowrap md:w-1/4 md:h-[3.5rem] px-5 py-4 bg-[#04D36B] font-semibold text-lg md:text-2xl text-white rounded-full tracking-wider">
            <div className="bg-white p-1 flex justify-center items-center w-6 h-6 rounded-full">
              <CheckMarkIcon fill={"#04D36B"} />
            </div>
            Thank you!
          </div>
        </div>
      </div>
    </>
  );
}
